<template>
  <div>
    <!--    Cabecera con parte del vídeo-->
    <section class="bg-primary py-5 bg-trama">
      <div class="container">
        <div class="row d-flex align-items-center">
          <div class="col-12 text-white my-5">
            <h1>Esto es… nuestra Casa de Campo</h1>
          </div>

          <div class="col-12">
            <p class="subtitular text-white">
              Uno de los lugares más emblemáticos de Madrid es la Casa de Campo: un espacio donde cientos de familias se
              congregan para pasar un rato de ocio en un entorno natural cerca de la ciudad.
            </p>
            <p class="subtitular text-white">
              La Sierra Norte de Madrid es una inmensa Casa de Campo donde poder
              <strong
                >disfrutar del canto de los pájaros, los prados inabarcables y un ritmo de vida que invita a saborear el
                momento.</strong
              >
              ¿A qué esperas para conocerla con tu familia?
            </p>
          </div>
          <div class="col-12 mt-4">
            <img src="/img/icons/familias.svg" alt="Planes especiales para familias" class="mr-3" /><span
              class="text-black small"
              >Planes especiales para familias</span
            >
          </div>
          <div class="w100 my-5"></div>
        </div>
      </div>
    </section>

    <!--      Fin de cabecera-->
    <!--      Sección con scroll horizontal-->

    <div id="scroll-wrapper" class="container-fluid scroll-wrapper bg-light">
      <div id="scrollContainer" class="scroll-sections">
        <div id="fondo-puntos" style="overflow: hidden;width:50px;position:absolute;height: 100vh;left:70vh">
          <img src="/img/caminos/camino-1.svg" alt="" style="position: absolute;top:30%;z-index:2" />
        </div>

        <div class="row scroll-section d-flex align-items-center">
          <div class="col-lg-5 offset-lg-1 mt-5 mt-lg-0">
            <h2 class="mb-4">Planes con niños: aprendizaje, ¡y diversión!</h2>
            <p class="subtitular z-index-up">
              Quien tiene niños sabe bien que las apariencias engañan: ¿cómo pueden tener tanta energía estas personitas
              en miniatura? Deportes, juegos, cursos… ¡sus pilas no parecen agotarse! Imagina disponer
              <strong
                >un espacio natural inmenso donde observar animales en su propio hábitat, hacer ejercicio al aire libre
                y pasar un día inolvidable en familia.</strong
              >
              ¡Ese lugar está en la Sierra Norte de Madrid!
            </p>
            <a href="https://www.sierranortemadrid.org/restaurantes/" class="btn btn-primary mr-3 mt-2" target="_blank">
              ¿Dónde comer?
            </a>
            <a href="https://www.sierranortemadrid.org/alojamiento/" class="btn btn-primary mt-2" target="_blank">
              ¿Dónde alojarse?
            </a>
          </div>
          <div class="col-lg-5 offset-lg-1 mt-5 mt-lg-0">
            <div class="row">
              <div class="col-12 px-0 z-index-down">
                <img src="/img/rutas/ruta2/embalse-riosequillo.jpg" alt="" class="img-fluid" />
              </div>
              <!--              Capa visible Movil-->
              <div class="col-lg-10 z-index-up d-lg-none">
                <h3 class="mt-5 mb-3">Embalse de Riosequillo</h3>
                <ul class="actividades">
                  <li>
                    <span>
                      <a
                        href="https://www.buitrago.org/turismo/rutas-desde-buitrago-del-lozoya"
                        target="_blank"
                        alt="Más información sobre el embalse"
                        >Este embalse</a
                      >
                      fue inaugurado en 1958, y en él pueden hacerse pequeñas
                      <strong>rutas a pie, en bici o a caballo,</strong> ya que se trata de un camino de unos 6
                      kilómetros muy cómodo de recorrer.
                    </span>
                  </li>
                  <li>
                    <span>
                      El sendero termina en el área recreativa de Riosequillo, que cuenta con merenderos, parque
                      infantil y piscinas. ¿Sabías que la
                      <strong>piscina de Riosequillo es la piscina natural más grande de España?</strong>
                    </span>
                  </li>
                </ul>
                <div class="row iconos-actividades d-flex justify-content-center justify-content-lg-start">
                  <icon-time duration="2-3h" />
                  <icon-verano />
                  <icon-parejas />
                  <icon-influencers />
                </div>
              </div>
              <!--              Capa visible Escritorio -->
              <div class="col-lg-10 z-index-up d-none d-lg-block">
                <h3 class="mt-5 mb-3">Embalse de Riosequillo</h3>
                <p>
                  Un espacio natural en el que podéis relajaros, hacer deporte o daros un chapuzón en temporada estival.
                </p>
                <div class="mb-4">
                  <b-button v-b-modal.modal1 variant="secondary">Más información</b-button>
                </div>
                <div class="row iconos-actividades d-flex justify-content-center justify-content-lg-start">
                  <icon-time duration="2-3h" />
                  <icon-verano />
                  <icon-parejas />
                  <icon-influencers />
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--          Inicio "2" slider************-->
        <div class="row scroll-section d-flex align-items-center">
          <div class="col-lg-5 offset-lg-1 z-index-top mt-5 mt-lg-0">
            <div class="row flex-lg-column-reverse">
              <div class="col-12 px-0 z-index-up">
                <img src="/img/rutas/ruta2/casa-arbol.jpg" alt="" class="img-fluid mt-0 mt-lg-3" />
              </div>
              <!--              Capa visible Movil-->
              <div class="col-lg-10 z-index-up d-lg-none">
                <h3 class="mt-5 mb-3">Casas en árboles de Gargantilla del Lozoya</h3>
                <ul class="actividades">
                  <li>
                    <span>
                      ¡El sueño de cualquier niño, y de muchos adultos!
                      <strong
                        ><a
                          href="https://www.sierranortemadrid.org/planes/cabana-en-los-arboles"
                          target="_blank"
                          alt="Más información sobre el alojamiento"
                          >Cabañas situadas en las copas de los árboles,</a
                        >
                        entre 4 y 7 metros de altura.</strong
                      >
                    </span>
                  </li>
                  <li>
                    <span>
                      Disfruta de unas vistas espectaculares del Parque Nacional Sierra de Guadarrama mientras escuchas
                      el sonido de los pájaros y observas cómo picotean en la terraza de la cabaña los carboneros o los
                      pinzones.
                    </span>
                  </li>
                  <li>
                    <span> <strong>Hay casitas de distintos tamaños:</strong> para 2 personas, para 4 y para 5. </span>
                  </li>
                </ul>
                <div class="row iconos-actividades d-flex justify-content-center justify-content-lg-start">
                  <icon-time duration="45m-2h" />
                  <icon-todas-estaciones />
                  <icon-aventureros />
                </div>
              </div>
              <!--              Capa visible Escritorio-->
              <div class="col-lg-10 z-index-up d-none d-lg-block">
                <h3 class="mt-5 mb-3">Casas en árboles de Gargantilla del Lozoya</h3>
                <p>
                  ¿Queréis sentiros como Tom Sawyer o Peter Pan? ¡Las casas en los árboles no existen solo en los
                  cuentos!
                </p>
                <div class="mb-4">
                  <b-button v-b-modal.modal2 variant="secondary">Más información</b-button>
                </div>
                <div class="row iconos-actividades d-flex justify-content-center justify-content-lg-start">
                  <icon-time duration="45m-2h" />
                  <icon-todas-estaciones />
                  <icon-aventureros />
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-5 offset-lg-1 mt-5 mt-lg-0">
            <div class="row">
              <div class="col-12 px-0 z-index-down">
                <img src="/img/rutas/ruta2/ganaderia.jpg" alt="" class="img-fluid" />
              </div>
              <!--              Capa visible Movil-->
              <div class="col-lg-10 z-index-up d-lg-none">
                <h3 class="mt-5 mb-3">Faenas del campo en Garganta de los Montes</h3>
                <ul class="actividades">
                  <li>
                    <span>
                      Si a tus peques les entusiasman los animales,
                      <a
                        href="https://www.sierranortemadrid.org/planes/fin-de-semana-agroturismo"
                        target="_blank"
                        alt="Más información sobre las faenas de campo"
                        >este plan les encantará.</a
                      >
                      <strong>Podréis ver vacas, burros, ovejas, gallinas, caballos,...</strong>
                    </span>
                  </li>
                  <li>
                    <span>
                      ¿Qué mejor manera de desarrollar su amor por la naturaleza que dándole de comer a las gallinas o
                      montando en burrito? Es posible pasar todo el fin de semana realizando diversas actividades.
                    </span>
                  </li>
                </ul>
                <div class="row iconos-actividades d-flex justify-content-center justify-content-lg-start">
                  <icon-parejas />
                  <icon-todas-estaciones />
                </div>
              </div>
              <!--              Capa visible Escritorio-->
              <div class="col-lg-10 z-index-up d-none d-lg-block">
                <h3 class="mt-5 mb-3">Faenas del campo en Garganta de los Montes</h3>
                <p>¡Nada como convivir con animales para que tus hijos desarrollen su amor por la naturaleza!</p>
                <div class="mb-4">
                  <b-button v-b-modal.modal3 variant="secondary">Más información</b-button>
                </div>
                <div class="row iconos-actividades d-flex justify-content-center justify-content-lg-start">
                  <icon-parejas />
                  <icon-todas-estaciones />
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--          Fin "2" slider ******************-->
        <!--          Inicio "3" slider************-->
        <div class="row scroll-section d-flex align-items-center">
          <div class="col-lg-5 offset-lg-1 z-index-top mt-5 mt-lg-0">
            <div class="row flex-lg-column-reverse">
              <div class="col-12 px-0 z-index-up">
                <img src="/img/rutas/ruta2/apicultura.jpg" alt="" class="img-fluid mt-0 mt-lg-3" />
              </div>
              <!--              Capa visible Movil-->
              <div class="col-lg-10 z-index-up d-lg-none">
                <h3 class="mt-5 mb-3">Apicultura</h3>
                <ul class="actividades">
                  <li>
                    <span>
                      <strong>¿Sabías que las abejas,</strong> debido a la polinización,
                      <strong>cumplen una función clave para el mantenimiento de la biodiversidad</strong> de nuestro
                      planeta?
                    </span>
                  </li>
                  <li>
                    <span>
                      Aunque se trata de
                      <a
                        href="https://www.sierranortemadrid.org/actividades/educacion-ambiental-naturaleza-agroecologia/apicultura"
                        target="_blank"
                        alt="Más información sobre la actividad de apicultura"
                        >una actividad 100% segura,</a
                      >
                      no está recomendada para niños menores de 6 años, y tampoco es posible acudir si se tiene alergia
                      a las picaduras de abeja.
                    </span>
                  </li>
                  <li>
                    <span>
                      <strong>En los meses de más frío</strong> (desde finales de octubre hasta principios de febrero)
                      <strong>no es posible realizar esta actividad,</strong> ya que las condiciones climatológicas
                      pueden afectar a la vida de las abejas.
                    </span>
                  </li>
                </ul>
                <div class="row iconos-actividades d-flex justify-content-center justify-content-lg-start">
                  <icon-time duration="3-4h" />
                  <icon-foodies />
                  <icon-verano />
                  <icon-primavera />
                </div>
              </div>
              <!--              Capa visible Escritorio-->
              <div class="col-lg-10 z-index-up d-none d-lg-block">
                <h3 class="mt-5 mb-3">Apicultura</h3>
                <p>
                  ¿Quieres inculcarles a tus peques el cuidado por el medioambiente? ¡Venid a nuestro taller de
                  apicultura!
                </p>
                <div class="mb-4">
                  <b-button v-b-modal.modal4 variant="secondary">Más información</b-button>
                </div>
                <div class="row iconos-actividades d-flex justify-content-center justify-content-lg-start">
                  <icon-time duration="3-4h" />
                  <icon-foodies />
                  <icon-verano />
                  <icon-primavera />
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-5 offset-lg-1 mt-5 mt-lg-0">
            <div class="row">
              <div class="col-12 px-0 z-index-down">
                <img src="/img/rutas/ruta2/bike.jpg" alt="" class="img-fluid" />
              </div>
              <!--              Capa visible Movil-->
              <div class="col-lg-10 z-index-up d-lg-none">
                <h3 class="mt-5 mb-3">Bici por el camino natural del Valle</h3>
                <ul class="actividades">
                  <li>
                    <span>
                      <a
                        href="https://www.sierranortemadrid.org/camino-natural-del-valle/"
                        target="_blank"
                        alt="Más información sobre las rutas en bicicleta"
                        >Esta ruta</a
                      >
                      se realiza entre El Cuadrón y el Puente del Perdón (Rascafría), con
                      <strong>una distancia total de unos 32 kilómetros solo de ida.</strong> La ruta parte del Paular a
                      Rascafría, y continúa hacia Oteruelo, Alameda del Valle, Pinilla del Valle, Lozoya, Garganta de
                      Los Montes y El Cuadrón.
                    </span>
                  </li>
                  <li>
                    <span>
                      <strong>Ruta especialmente apropiada para hacer por etapas,</strong> pernoctando en cualquiera de
                      los puntos del recorrido.
                    </span>
                  </li>
                  <li>
                    <span>
                      <strong>Se puede hacer tanto a pie como en bicicleta,</strong> ya que no hay grandes desniveles,
                      siendo su dificultad fácil/media.
                    </span>
                  </li>
                </ul>
                <div class="row iconos-actividades d-flex justify-content-center justify-content-lg-start">
                  <icon-todas-estaciones />
                  <icon-aventureros />
                  <icon-parejas />
                </div>
              </div>
              <!--              Capa visible Escritorio-->
              <div class="col-lg-10 z-index-up d-none d-lg-block">
                <h3 class="mt-5 mb-3">Bici por el camino natural del Valle</h3>
                <p>
                  ¿Lo que más os gusta es practicar deporte en familia? Preparad las bicis…¡nos vemos en la Sierra Norte
                  de Madrid!
                </p>
                <div class="mb-4">
                  <b-button v-b-modal.modal5 variant="secondary">Más información</b-button>
                </div>
                <div class="row iconos-actividades d-flex justify-content-center justify-content-lg-start">
                  <icon-todas-estaciones />
                  <icon-aventureros />
                  <icon-parejas />
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--          Fin "3" slider ******************-->

        <!--          Inicio "4" slider************-->
        <div class="row scroll-section d-flex align-items-center">
          <div class="col-lg-5 offset-lg-1 z-index-top my-5 my-lg-0">
            <div class="row flex-lg-column-reverse">
              <div class="col-12 px-0 z-index-up ">
                <img src="/img/rutas/ruta2/parque-cuerdas.jpg" alt="" class="img-fluid mt-0 mt-lg-3" />
              </div>
              <!--              Capa visible Movil-->
              <div class="col-lg-10 z-index-up d-lg-none mb-4">
                <h3 class="mt-5 mb-3">Parque de aventuras de cuerdas en Lozoya del Valle</h3>
                <ul class="actividades">
                  <li>
                    <span>
                      ¡Diversión garantizada para toda la familia! Disfruta con tus niños en un
                      <a
                        href="https://www.sierranortemadrid.org/planes/parque-aventuras"
                        target="_blank"
                        alt="Más información sobre el parque de cuerdas"
                        >parque de cuerdas</a
                      >
                      que, además, <strong>puedes complementar con otras actividades</strong> (piragua, raquetas de
                      nieve, bici de montaña, paddle surf,...) dependiendo de la época del año.
                    </span>
                  </li>
                  <li>
                    <span>
                      Esta actividad es <strong>apta para personas de todas las edades:</strong> para los más peques hay
                      un parque de bolas, castillo hinchable y cama elástica; mientras que para los adultos hay un
                      parque con 3 alturas y tirolinas.
                    </span>
                  </li>
                </ul>
                <div class="row iconos-actividades d-flex justify-content-center justify-content-lg-start">
                  <icon-time duration="4h" />
                  <icon-aventureros />
                  <icon-todas-estaciones />
                </div>
              </div>

              <!--              Capa visible Escritorio-->
              <div class="col-lg-10 z-index-up d-none d-lg-block">
                <h3 class="mt-5 mb-3">Parque de aventuras de cuerdas en Lozoya del Valle</h3>
                <p>Ven con tus peques a hacer ejercicio al aire libre. ¡Diversión garantizada para toda la familia!</p>
                <div class="mb-4">
                  <b-button v-b-modal.modal6 variant="secondary">Más información</b-button>
                </div>
                <div class="row iconos-actividades d-flex justify-content-center justify-content-lg-start">
                  <icon-time duration="4h" />
                  <icon-aventureros />
                  <icon-todas-estaciones />
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--          Fin "4" slider ******************-->
      </div>
    </div>
    <!--    Fin sección scroll horizontal-->
    <!--    Inicio modals-->

    <!--   Inicio Modal 1-->
    <b-modal id="modal1" centered scrollable size="lg" hide-footer title="Embalse de Riosequillo">
      <div class="container">
        <div class="row">
          <ul class="actividades">
            <li>
              <span>
                <a
                  href="https://www.buitrago.org/turismo/rutas-desde-buitrago-del-lozoya"
                  target="_blank"
                  alt="Más información sobre el embalse"
                  >Este embalse</a
                >
                fue inaugurado en 1958, y en él pueden hacerse pequeñas
                <strong>rutas a pie, en bici o a caballo,</strong> ya que se trata de un camino de unos 6 kilómetros muy
                cómodo de recorrer.
              </span>
            </li>
            <li>
              <span>
                El sendero termina en el área recreativa de Riosequillo, que cuenta con merenderos, parque infantil y
                piscinas. ¿Sabías que la
                <strong>piscina de Riosequillo es la piscina natural más grande de España?</strong>
              </span>
            </li>
          </ul>
        </div>
      </div>
    </b-modal>
    <!--    Fin Modal 1-->
    <!--   Inicio Modal 2-->
    <b-modal id="modal2" centered scrollable size="lg" hide-footer title="Casas en árboles de Gargantilla del Lozoya">
      <div class="container">
        <div class="row">
          <ul class="actividades">
            <li>
              <span>
                ¡El sueño de cualquier niño, y de muchos adultos!
                <strong
                  ><a
                    href="https://www.sierranortemadrid.org/planes/cabana-en-los-arboles"
                    target="_blank"
                    alt="Más información sobre el alojamiento"
                    >Cabañas situadas en las copas de los árboles,</a
                  >
                  entre 4 y 7 metros de altura.</strong
                >
              </span>
            </li>
            <li>
              <span>
                Disfruta de unas vistas espectaculares del Parque Nacional Sierra de Guadarrama mientras escuchas el
                sonido de los pájaros y observas cómo picotean en la terraza de la cabaña los carboneros o los pinzones.
              </span>
            </li>
            <li>
              <span> <strong>Hay casitas de distintos tamaños:</strong> para 2 personas, para 4 y para 5. </span>
            </li>
          </ul>
        </div>
      </div>
    </b-modal>
    <!--    Fin Modal 2-->
    <!--   Inicio Modal 3-->
    <b-modal id="modal3" centered scrollable size="lg" hide-footer title="Faenas del campo en Garganta de los Montes">
      <div class="container">
        <div class="row">
          <ul class="actividades">
            <li>
              <span>
                Si a tus peques les entusiasman los animales,
                <a
                  href="https://www.sierranortemadrid.org/planes/fin-de-semana-agroturismo"
                  target="_blank"
                  alt="Más información sobre las faenas de campo"
                  >este plan les encantará.</a
                >
                <strong>Podréis ver vacas, burros, ovejas, gallinas, caballos,...</strong>
              </span>
            </li>
            <li>
              <span>
                ¿Qué mejor manera de desarrollar su amor por la naturaleza que dándole de comer a las gallinas o
                montando en burrito? Es posible pasar todo el fin de semana realizando diversas actividades.
              </span>
            </li>
          </ul>
        </div>
      </div>
    </b-modal>
    <!--    Fin Modal 3-->
    <!--   Inicio Modal 4-->
    <b-modal id="modal4" centered scrollable size="lg" hide-footer title="Apicultura">
      <div class="container">
        <div class="row">
          <ul class="actividades">
            <li>
              <span>
                <strong>¿Sabías que las abejas,</strong> debido a la polinización,
                <strong>cumplen una función clave para el mantenimiento de la biodiversidad</strong> de nuestro planeta?
              </span>
            </li>
            <li>
              <span>
                Aunque se trata de
                <a
                  href="https://www.sierranortemadrid.org/actividades/educacion-ambiental-naturaleza-agroecologia/apicultura"
                  target="_blank"
                  alt="Más información sobre la actividad de apicultura"
                  >una actividad 100% segura,</a
                >
                no está recomendada para niños menores de 6 años, y tampoco es posible acudir si se tiene alergia a las
                picaduras de abeja.
              </span>
            </li>
            <li>
              <span>
                <strong>En los meses de más frío</strong> (desde finales de octubre hasta principios de febrero)
                <strong>no es posible realizar esta actividad,</strong> ya que las condiciones climatológicas pueden
                afectar a la vida de las abejas.
              </span>
            </li>
          </ul>
        </div>
      </div>
    </b-modal>
    <!--    Fin Modal 4-->
    <!--   Inicio Modal 5-->
    <b-modal id="modal5" centered scrollable size="lg" hide-footer title="Bici por el camino natural del Valle">
      <div class="container">
        <div class="row">
          <ul class="actividades">
            <li>
              <span>
                <a
                  href="https://www.sierranortemadrid.org/camino-natural-del-valle/"
                  target="_blank"
                  alt="Más información sobre las rutas en bicicleta"
                  >Esta ruta</a
                >
                se realiza entre El Cuadrón y el Puente del Perdón (Rascafría), con
                <strong>una distancia total de unos 32 kilómetros solo de ida.</strong> La ruta parte del Paular a
                Rascafría, y continúa hacia Oteruelo, Alameda del Valle, Pinilla del Valle, Lozoya, Garganta de Los
                Montes y El Cuadrón.
              </span>
            </li>
            <li>
              <span>
                <strong>Ruta especialmente apropiada para hacer por etapas,</strong> pernoctando en cualquiera de los
                puntos del recorrido.
              </span>
            </li>
            <li>
              <span>
                <strong>Se puede hacer tanto a pie como en bicicleta,</strong> ya que no hay grandes desniveles, siendo
                su dificultad fácil/media.
              </span>
            </li>
          </ul>
        </div>
      </div>
    </b-modal>
    <!--    Fin Modal 5-->
    <!--   Inicio Modal 6-->
    <b-modal
      id="modal6"
      centered
      scrollable
      size="lg"
      hide-footer
      title="Parque de aventuras de cuerdas en Lozoya del Valle"
    >
      <div class="container">
        <div class="row">
          <ul class="actividades">
            <li>
              <span>
                ¡Diversión garantizada para toda la familia! Disfruta con tus niños en un
                <a
                  href="https://www.sierranortemadrid.org/planes/parque-aventuras"
                  target="_blank"
                  alt="Más información sobre el parque de cuerdas"
                  >parque de cuerdas</a
                >
                que, además, <strong>puedes complementar con otras actividades</strong> (piragua, raquetas de nieve,
                bici de montaña, paddle surf,...) dependiendo de la época del año.
              </span>
            </li>
            <li>
              <span>
                Esta actividad es <strong>apta para personas de todas las edades:</strong> para los más peques hay un
                parque de bolas, castillo hinchable y cama elástica; mientras que para los adultos hay un parque con 3
                alturas y tirolinas.
              </span>
            </li>
          </ul>
        </div>
      </div>
    </b-modal>
    <!--    Fin Modal 6-->
    <!--    Fin de modal-->
  </div>
</template>

<script>
import { TimelineMax } from 'gsap'

export default {
  components: {
    IconTime: () => import('../../components/iconos/IconTime'),
    // IconCulturetas: () => import('../../components/iconos/IconCulturetas'),
    IconVerano: () => import('../../components/iconos/IconVerano'),
    // IconDistance: () => import('../../components/iconos/IconDistance'),
    // IconFamilias: () => import('../../components/iconos/IconFamilias'),
    IconFoodies: () => import('../../components/iconos/IconFoodies'),
    IconInfluencers: () => import('../../components/iconos/IconInfluencers'),
    // IconInvierno: () => import('../../components/iconos/IconInvierno'),
    // IconOtono: () => import('../../components/iconos/IconOtono'),
    IconParejas: () => import('../../components/iconos/IconParejas'),
    IconPrimavera: () => import('../../components/iconos/IconPrimavera'),
    IconTodasEstaciones: () => import('../../components/iconos/IconTodasEstaciones'),
    IconAventureros: () => import('../../components/iconos/IconAventureros')
  },
  mounted() {
    if (window.innerWidth > 1000) {
      const horizontalSlide = new TimelineMax().to('#scrollContainer', 1, { x: '-50%' })
      const scene = this.$scrollmagic
        .scene({
          triggerElement: '#scroll-wrapper',
          triggerHook: 'onLeave',
          duration: '400%'
        })
        .setPin('#scroll-wrapper')
        .setTween(horizontalSlide)
      const scene2 = this.$scrollmagic
        .scene({
          triggerElement: '#scroll-wrapper',
          triggerHook: 'onLeave',
          duration: '400%'
        })
        .setTween('#fondo-puntos', {
          width: '60%'
        })

      this.$scrollmagic.addScene(scene)
      this.$scrollmagic.addScene(scene2)
    }
  }
}
</script>
